module.exports = __webpack_public_path__ + "img/Huafeng_Xu.4d48d5ee.jpg";